import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Driver'],
});
// Define a service using a base URL and expected endpoints
export const driverApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllDrivers: builder.query({
      query: () => `drivers/`,
      providesTags: ['Driver'],
    }),
    findAllDriversOfBzp: builder.query({
      query: (code) => `drivers/?bzp__code=${code}`,
      providesTags: ['Driver'],
    }),
    findDriverById: builder.query({
      query: (id) => `drivers/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Driver', id: result.id }] : ['Driver'];
      },
    }),
    createDriver: builder.mutation({
      query: (Driver) => ({
        url: `drivers/`,
        method: 'POST',
        body: Driver,
      }),
      invalidatesTags: ['Driver'],
    }),
    updateDriver: builder.mutation({
      query: (Driver) => ({
        url: `drivers/${Driver.id}/`,
        method: 'PATCH',
        body: Driver,
      }),
      invalidatesTags: ['Driver'],
    }),
    deleteDriver: builder.mutation({
      query: (Driver) => ({
        url: `drivers/${Driver.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Driver'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllDriversQuery,
  useFindAllDriversOfBzpQuery,
  useFindDriverByIdQuery,
  useCreateDriverMutation,
  useUpdateDriverMutation,
  useDeleteDriverMutation,
} = driverApi;
